import { publishedArticles } from "@/content/generatedBlog";

export const publishedArticlesForLocale = (locale = "es") => publishedArticles.filter((article) => article.locale === locale);

export const articlesNewestFirst = (locale = "es") => [...publishedArticlesForLocale(locale)].sort((left, right) =>
  Date.parse(right.publishedAt) - Date.parse(left.publishedAt)
);

export const articlesForNavigation = (locale = "es") => [...publishedArticlesForLocale(locale)].sort((left, right) => left.order - right.order);

export const featuredArticle = (locale = "es") => articlesNewestFirst(locale).find((article) => article.featured) || null;

export function findPublishedArticle(slug, locale = "es") {
  return publishedArticles.find((article) => article.locale === locale && article.slug === slug) || null;
}

export function relatedPublishedArticles(article, limit = 3) {
  const tags = new Set(article.tags || []);
  return publishedArticlesForLocale(article.locale)
    .filter((candidate) => candidate.slug !== article.slug)
    .map((candidate) => ({
      article: candidate,
      score: (candidate.category === article.category ? 3 : 0) +
        (candidate.tags || []).filter((tag) => tags.has(tag)).length,
    }))
    .filter((candidate) => candidate.score > 0)
    .sort((left, right) => right.score - left.score || Date.parse(right.article.publishedAt) - Date.parse(left.article.publishedAt))
    .slice(0, limit)
    .map((candidate) => candidate.article);
}

export function articlePath(article) {
  return article.path;
}
